{
  "menu": {
    "header": "Databases",
    "items": {
      "databases": "Databases",
      "clientes": "Clientes",
      "views": "Views",
      "media": "Media y Archivos",
      "users": "Usuarios",
      "agents": "Agentes",
      "mail": "Correo",
      "recording": "Grabación de Videos",
      "triggers": "Triggers",
      "knowledge": "Grafo de Conocimiento",
      "tags": "Tags Semánticos",
      "payments": "Link de Pagos"
    }
  },
  "registry": {
    "breadcrumb": {
      "views": "databases > vistas",
      "media": "databases > medios",
      "triggers": "databases > triggers",
      "graph": "databases > grafo",
      "tags": "semántica",
      "general": "databases > general"
    },
    "columns": {
      "name": "Nombre",
      "idData": "ID Data",
      "rowCount": "Filas",
      "views": "Vistas",
      "createdAt": "Creado"
    },
    "openTable": "Abrir tabla",
    "noName": "(Sin Nombre)"
  },
  "viewPage": {
    "loading": "Cargando tabla...",
    "noViews": "Esta tabla no tiene ninguna vista disponible.",
    "backButton": "Volver a Databases"
  },
  "table": {
    "loading": "Cargando datos...",
    "error": {
      "notFoundTitle": "Tabla o Vista no encontrada",
      "genericTitle": "Error cargando tabla",
      "notFoundDetail": "Es posible que esta vista haya sido eliminada."
    },
    "search": {
      "placeholder": "Buscar...",
      "aria": "Buscar en la tabla"
    },
    "untitledView": "Sin título",
    "viewNameLoading": "Cargando...",
    "tableFallbackName": "Tabla",
    "view": {
      "copyFullIdTitle": "Click para copiar ID completo",
      "copyFullIdAria": "Copiar ID completo de la vista",
      "copyIdTitle": "Click para copiar ID",
      "copyIdAria": "Copiar ID de la vista",
      "configure": "Configurar Vista",
      "delete": "Eliminar Vista",
      "noOtherViews": "No hay otras vistas",
      "deleteConfirm": "¿Estás seguro que deseas eliminar la vista \"{{name}}\"? La tabla de datos no se borrará.",
      "deletedInfo": "Vista eliminada. No quedan otras vistas visibles.",
      "deleteError": "Error al eliminar vista: {{error}}",
      "deleteNetworkError": "Error de conexión al eliminar vista"
    },
    "flowToggle": {
      "on": "Volver a Tabla",
      "off": "Ver como Tablero / Flow"
    },
    "row": {
      "deleteTitle": "Eliminar fila",
      "deleteConfirm": "¿Eliminar fila permanentemente?",
      "deleteError": "Error al eliminar la fila",
      "addRow": "Nueva fila",
      "addRowError": "Error añadiendo fila: {{error}}"
    },
    "column": {
      "createError": "Error creando columna: {{error}}",
      "createNetworkError": "Error de red al crear columna"
    },
    "pagination": {
      "prev": "Anterior",
      "next": "Siguiente",
      "pageInfo": "Página {{current}} de {{total}}",
      "items": "{{count}} elementos"
    },
    "noRowsFound": "No se encontraron filas",
    "noColumnsFound": "No se encontraron columnas"
  },
  "flow": {
    "addText": "Agregar Texto",
    "addLine": "Agregar Línea",
    "cancel": "Cancelar",
    "showAllRows": "Mostrar todas las filas",
    "hidePlacedRows": "Ocultar filas ya colocadas",
    "searchRows": {
      "placeholder": "Buscar filas y arrastrar...",
      "aria": "Buscar filas para arrastrar al Tablero"
    },
    "selectColumn": {
      "placeholder": "Selecciona columna...",
      "aria": "Buscar y seleccionar columna del Tablero"
    },
    "textNodePlaceholder": "Escribe texto...",
    "textNodeAria": "Texto del nodo",
    "increaseLineWidth": "Aumentar grosor de línea",
    "decreaseLineWidth": "Reducir grosor de línea",
    "deleteLine": "Borrar línea",
    "increaseFontSize": "Aumentar tamaño de fuente",
    "decreaseFontSize": "Reducir tamaño de fuente",
    "deleteTextNode": "Borrar nodo de texto",
    "deleteConnection": "Borrar conexión",
    "assignedTo": "Encargado: {{name}}",
    "unknownUser": "Usuario",
    "statusAria": "Estado: {{label}}"
  },
  "cells": {
    "persona": {
      "selectPlaceholder": "Seleccionar persona...",
      "searchPlaceholder": "Buscar personas...",
      "noUsersFound": "No se encontraron usuarios"
    },
    "fecha": {
      "months": ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
      "dayLetters": ["D", "L", "M", "M", "J", "V", "S"],
      "placeholder": "Fecha",
      "assignPersonPlaceholder": "Asignar persona...",
      "copyIdTitle": "Click para copiar ID",
      "durationConfiguredTitle": "Tiempo configurado desde el calendario",
      "defaultEventTitle": "Evento",
      "eventDescription": "Asignado a: {{name}}. Fecha: {{date}}",
      "status": {
        "completed": "{{count}} días (Completado)",
        "elapsed_one": "{{count}} día trascurrido",
        "elapsed_other": "{{count}} días trascurridos",
        "daysLeft_one": "Falta un día",
        "daysLeft_other": "Faltan {{count}} días",
        "daysLate_one": "1 día de retraso",
        "daysLate_other": "{{count}} días de retraso"
      },
      "networkError": "Error de red",
      "saveError": "Error al guardar fecha"
    },
    "texto": {
      "placeholder": "Vacío",
      "goToPage": "Ir a página",
      "copyLinkIdTitle": "Copiar ID de enlace"
    },
    "tag": {
      "addPlaceholder": "Agregar tag...",
      "createOption": "Crear \"{{value}}\""
    },
    "numero": {
      "minutesPlaceholder": "Minutos ej. 45",
      "errorSavingTitle": "Error al guardar"
    },
    "filesAndMedia": {
      "addFileTitle": "Agregar archivo",
      "dropHint": "Haz clic o arrastra archivos aquí",
      "dropSubtext": "Soporta imágenes, pdf, documentos",
      "uploadError": "Error al subir {{fileName}}"
    },
    "descripcion": {
      "placeholder": "Agregar descripción (390 caracteres)..."
    },
    "menuDesplegable": {
      "placeholder": "Seleccionar...",
      "searchOrCreatePlaceholder": "Buscar o crear...",
      "deleteOptionTitle": "Eliminar opción",
      "createOption": "Crear \"{{value}}\"",
      "typeToSearch": "Escribe para buscar o crear"
    }
  }
}
